










































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  MAIN_DATA_SHOW_TYPE_DATE,
  MAIN_DATA_SHOW_TYPE_FILE,
  MAIN_DATA_SHOW_TYPE_VIDEO,
  MAIN_DATA_SHOW_TYPE_AUDIO,
  MAIN_DATA_SHOW_TYPE_IMAGE,
  MAIN_DATA_SHOW_TYPE_DATE_TIME,
  dateFormat,
  getPdfViewUrl
} from "@szgc/plt-core-v2";

@Component({
  name: "MainObject",
  components: {}
})
export default class MainObject extends Vue {
  @Prop({
    required: true
  })
  private data!: any;

  @Prop({
    required: true
  })
  private field!: {
    fieldDescription: string;
    fieldName: string;
    fieldType: string;
    typeDescript: string;
  };

  get value() {
    return this.data[this.field.fieldName];
  }

  get isDate() {
    return this.field.typeDescript === MAIN_DATA_SHOW_TYPE_DATE.value;
  }

  get isDateTime() {
    return this.field.typeDescript === MAIN_DATA_SHOW_TYPE_DATE_TIME.value;
  }

  get isFile() {
    return this.field.typeDescript === MAIN_DATA_SHOW_TYPE_FILE.value;
  }

  get isVideo() {
    return this.field.typeDescript === MAIN_DATA_SHOW_TYPE_VIDEO.value;
  }

  get isAudio() {
    return this.field.typeDescript === MAIN_DATA_SHOW_TYPE_AUDIO.value;
  }

  get isImage() {
    return this.field.typeDescript === MAIN_DATA_SHOW_TYPE_IMAGE.value;
  }

  get isPdf() {
    const value = this.data[this.field.fieldName];
    const reg = /\.pdf$/;
    return reg.test(value);
  }

  dateFormat(formatter: string = "YYYY-MM-DD") {
    const str = dateFormat(this.value - 0, formatter);
    return str === "Invalid date" ? "" : str;
  }

  save() {
    const a = document.createElement("a");
    a.href = this.value;
    const arr = this.value.split("/");
    a.download = arr[arr.length - 1];
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async view() {
    const src = await getPdfViewUrl(this.value);
    window.open(src);
  }
}
